import React from "react";
import { useTranslation } from "react-i18next";

import { useEmployeeStore } from "~/stores/use-employee-store";
import { usePermissionStore } from "~/stores/use-permission-store";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

export default function NoPermissionAlert() {
  const { noPermissionOpen, setNoPermissionOpen } = usePermissionStore();
  const { t } = useTranslation("common");
  return (
    <AlertDialog onOpenChange={setNoPermissionOpen} open={noPermissionOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("no_permission")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("no_permission_description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction>{t("ok")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
